// extracted by mini-css-extract-plugin
export default {"selection":"styles_selection__ADJhf","selectionHeight":"styles_selectionHeight__tTAfd"};